export const feVar = key => {
  if (FRONTEND_EXPERIENCE && key in FRONTEND_EXPERIENCE) {
    return FRONTEND_EXPERIENCE[key];
  }
  return undefined;
};
